<template>
  <div class="all-content ">
    <div class="content snow">
      <div class="cdkey">
        <div class="key_info">
          <p>兑换码：{{ state.cdkeyCode }}</p>
          <p>‘我的-福利兑换’处兑换</p>
        </div>
        <img
          src="../../../assets/webActivity/charistmas/copy_btn.png"
          alt=""
          class="copy_bth animate__animated animate__pulse"
          id="copy-btn"
          @click="copyShareUrl('#copy-btn')"
        />
        <img
          src="../../../assets/webActivity/charistmas/key_info_gift.png"
          alt=""
          class="info_gift"
        />
      </div>
      <div class="coupon">
        <div class="swiper">
          <div class="swiper-wrapper" ref="slides">
            <img
              v-for="(img, index) in state.images"
              :key="index"
              :src="img.src"
              :alt="img.alt"
              class="swiper-slide"
            />
          </div>
        </div>
        <img
          src="../../../assets/webActivity/charistmas/coupon_btn.png"
          alt=""
          class="animate__animated animate__pulse"
          @click="getCoupon()"
        />
        <img
          src="../../../assets/webActivity/charistmas/snowman_ico.png"
          alt=""
          class="snow_man"
        />
      </div>
      <div class="rule">
        <h4>活动时间：12月25日</h4>
        <p>
          1、福利1领取的兑换码请当天尽快兑换使用，活动结束后将无法使用；
        </p>
        <p>
          2、福利2领取的优惠券仅限0.1和0.05折游戏使用，领取后7天内有效；
        </p>
        <p>
          3、0.1折对新用户的界定有严格的判断，若识别为同一名用户，将无法获得奖励（同实名、手机号、设备、符合任意一条均视为同一用户）
        </p>
        <p>
          4、若检测发现邀请者存在利用漏洞获取不当利益的行为，我们将保留回收奖励的权力，并对该行为追加进一步的处罚。
        </p>
        <p>
          5、活动最终解释权归0.1折手游所有，如有疑问请联系客服。
        </p>
      </div>
    </div>
  </div>
</template>
<script setup>
import "animate.css";
import { handleCopy } from "@/utils/tool";
import { beginSnow } from "./snow";
import { nextTick, onMounted, reactive, ref } from "vue";
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "../../../utils/location";

const state = reactive({
  images: [
    {
      src: require("../../../assets/webActivity/charistmas/coupon_300.png"),
      alt: "Image 1",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_200.png"),
      alt: "Image 2",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_648_100.png"),
      alt: "Image 3",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_160.png"),
      alt: "Image 4",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_198_100.png"),
      alt: "Image 5",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_45.png"),
      alt: "Image 6",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_15.png"),
      alt: "Image 7",
    },
    {
      src: require("../../../assets/webActivity/charistmas/coupon_3.png"),
      alt: "Image 8",
    },
  ],

  cdkeyCode: "登陆后查看",
  uid: 0,
});

var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiper", {
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    speed: 1000, // 滑动速度，单位毫秒
    freeMode: true,
    slidesPerView: "auto", // 每次展示多个图片
    loop: true,
    allowTouchMove: true,
    initialSlide: 1,
    loop: true,
  });
};

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
  nextTick(() => {
    beginSnow();
    initSwiper();
    getChRistmasData();
  });
});

import { getChristmas, getChristmasCoupon } from "@/api/activity";
import { Toast } from "vant";
const getChRistmasData = async () => {
  // console.log("获取圣诞活动数据");
  let res = await getChristmas({
    uid: state.uid,
  });
  if (res.data.code == 1) {
    state.cdkeyCode = res.data.data.code ? res.data.data.code : "登陆后获取";
  }
  // console.log("圣诞活动数据", res);
};

// 复制链接按钮
const copyShareUrl = (id) => {
  if (!state.uid) {
    Toast("请先登录");
    return;
  }
  handleCopy(id, state.cdkeyCode);
};

let fetchFlag = false;
const getCoupon = async () => {
  if (fetchFlag) {
    return;
  }
  fetchFlag = true;
  console.log("领取优惠券");
  let res = await getChristmasCoupon({
    uid: state.uid,
  });
  fetchFlag = false;
  console.log("领取优惠券", res);
  Toast(res.data.msg);
};
</script>
<style scoped>
.all-content {
  width: 100%;
  height: 100vh;
  overflow: auto;
}
.content {
  position: relative;
  background-color: #3e91e9;
  background-image: url(../../../assets/webActivity/charistmas/christmas_banner.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-top: 600px;
}
.cdkey,
.coupon,
.rule {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.content .cdkey {
  height: 376px;
  background-image: url(../../../assets/webActivity/charistmas/cdkey_bg.png);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 48px;
  position: relative;
}
.content .coupon {
  height: 518px;
  background-image: url(../../../assets/webActivity/charistmas/coupon_bg.png);
  margin: 16px 0 22px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 212px;
  align-items: flex-end;
  position: relative;
}
.content .rule {
  height: 1172px;
  background-image: url(../../../assets/webActivity/charistmas/rule_bg.png);
  padding: 144px 74px;
  color: #822813;
  font-size: 28px;
}

.cdkey .key_info {
  width: 582px;
  height: 154px;
  border-radius: 20px;
  background-image: url(../../../assets/webActivity/charistmas/key_info_bg.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cdkey .key_info p {
  margin-left: -50px;
}
.cdkey .key_info p:nth-of-type(1) {
  font-weight: 600;
  font-size: 24px;
  color: #7e3103;
}
.cdkey .key_info p:nth-of-type(2) {
  font-weight: 500;
  font-size: 16px;
  color: #b47439;
  margin-top: 12px;
}
.cdkey .info_gift {
  width: 130px;
  height: 130px;
  position: absolute;
  bottom: -20px;
  left: 5px;
}
.cdkey .copy_bth {
  width: 140px;
  height: 72px;
  position: absolute;
  top: 216px;
  right: 100px;
  animation-iteration-count: infinite;
}

/* 优惠券 */
.swiper {
  display: flex;
  flex-wrap: nowrap;
  width: 632px;
  height: 154px;
  overflow: auto;
  touch-action: pan-y pinch-zoom;
  scrollbar-width: none;
  margin-bottom: 30px;
}
.swiper img {
  width: 166px;
  height: 132px;
  margin-right: 14px;
}
.coupon > img {
  width: 506px;
  height: 108px;
  display: block;
  margin-right: 56px;
  animation-iteration-count: infinite;
}
.coupon .snow_man {
  position: absolute;
  bottom: -20px;
  left: 5px;
  width: 176px;
  height: 208px;
  z-index: 2;
}

/* 规则 */
.content .rule h4 {
  color: #822813;
  margin-bottom: 28px;
}
.content .rule p {
  margin-bottom: 28px;
}
</style>
